module.exports = __webpack_public_path__ + "img/appstore.7bb15623.jpg";